<template>
  <el-container class="app-layout">
    <el-aside class="sidebar" width="280px">
      <div class="sidebar-bg"></div>
      <div class="sidebar-logo">
        <img src="@/assets/logo.png" alt="Logo" />
      </div>
      <el-menu :default-active="selectedNav" class="nav-menu" @select="selectNav" :style="{background: 'transparent'}">
        <el-menu-item
          v-for="item in navItems"
          :key="item.name"
          :index="item.name"
          class="navmenu"
          :class="{ 'navmenu-active': item.name === selectedNav }"
        >
          <img :src="item.name === selectedNav ? item.activeIcon : item.icon" class="nav-icon" />
          <span class="nav-text">{{ item.name }}</span>
          <img :src="item.name === selectedNav ? item.starActive : item.star" class="nav-star" />
        </el-menu-item>
      </el-menu>
    </el-aside>
    <el-container>
      <el-header class="header">
        <div class="header-nav-active">
          <img v-if="activeNavItem" :src="activeNavItem.activeIcon" class="header-nav-icon" />
          <span v-if="activeNavItem" class="header-nav-text">{{ activeNavItem.name }}</span>
        </div>
        <div class="user-info">
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              <i class="el-icon-user user-icon"></i> {{ username }}
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>
      <el-main class="content">
        <div v-if="selectedNav === '账号管理'"><account></account></div>
        <div v-if="selectedNav === '远程预警'"><device></device></div>
        <div v-if="selectedNav === '设备管理'"><RemoteWarning></RemoteWarning></div>
        <div v-if="selectedNav === '维修报修'"><repair></repair></div>
        <div v-if="selectedNav === '材料参数'"><MaterialParameters></MaterialParameters></div>
        <div v-if="selectedNav === '机构列表'"><OrgList></OrgList></div>
        <div v-if="selectedNav === '大屏看板'"><Dashboard></Dashboard></div>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import account from '../views/account.vue';
import device from '../views/device.vue';
import MaterialParameters from '../views/MaterialParameters.vue';
import repair from '../views/repair.vue';
import OrgList from '../views/OrgList.vue';
import RemoteWarning from '../views/RemoteWarning.vue';
import Dashboard from '../views/Dashboard.vue';
import axios from 'axios';
import { EventBus } from '@/utils/eventBus';

export default {
  data() {
    return {
      username: '用户姓名',
      institutionName: '', 
      selectedNav: '账号管理', 
      navItems: [
        {
          name: '账号管理',
          icon: require('@/assets/nav-account.png'),
          activeIcon: require('@/assets/nav-account-active.png'),
          star: require('@/assets/star.png'),
          starActive: require('@/assets/star-active.png')
        },
        {
          name: '远程预警',
          icon: require('@/assets/nav-warning.png'),
          activeIcon: require('@/assets/nav-warning-active.png'),
          star: require('@/assets/star.png'),
          starActive: require('@/assets/star-active.png')
        },
        {
          name: '设备管理',
          icon: require('@/assets/nav-device.png'),
          activeIcon: require('@/assets/nav-device-active.png'),
          star: require('@/assets/star.png'),
          starActive: require('@/assets/star-active.png')
        },
        {
          name: '维修报修',
          icon: require('@/assets/nav-repair.png'),
          activeIcon: require('@/assets/nav-repair-active.png'),
          star: require('@/assets/star.png'),
          starActive: require('@/assets/star-active.png')
        },
        {
          name: '材料参数',
          icon: require('@/assets/nav-material.png'),
          activeIcon: require('@/assets/nav-material-active.png'),
          star: require('@/assets/star.png'),
          starActive: require('@/assets/star-active.png')
        },
        {
          name: '机构列表',
          icon: require('@/assets/nav-org.png'),
          activeIcon: require('@/assets/nav-org-active.png'),
          star: require('@/assets/star.png'),
          starActive: require('@/assets/star-active.png')
        },
        {
          name: '大屏看板',
          icon: require('@/assets/nav-dashboard.png'),
          activeIcon: require('@/assets/nav-dashboard-active.png'),
          star: require('@/assets/star.png'),
          starActive: require('@/assets/star-active.png')
        }
      ],
      hasEquipmentWarning: false,
      userInfo: {}
    };
  },
  components: {
    account,
    device,
    MaterialParameters,
    repair,
    OrgList,
    RemoteWarning,
    Dashboard
  },
  computed: {
    activeNavItem() {
      return this.navItems.find(item => item.name === this.selectedNav);
    }
  },
  created() {
    this.fetchUserInfoByAccountNum();
    const savedNav = localStorage.getItem('selectedNav');
    if (savedNav) {
      this.selectedNav = savedNav; 
    }
    EventBus.$on('userNameUpdated', () => {
      this.fetchUserInfoByAccountNum();
    })
    EventBus.$on('equipmentWarningStatus', (status) => {
      this.hasEquipmentWarning = status;
    });
  },
  beforeDestroy() {
    EventBus.$off('userNameUpdated')
    EventBus.$off('equipmentWarningStatus');
  },
  methods: {
    selectNav(item) {
      this.selectedNav = item;
      localStorage.setItem('selectedNav', item);
    },
    handleCommand(command) {
      switch (command) {
        case 'profile':
          console.log('去我的资料');
          break;
        case 'change-password':
          console.log('去修改密码');
          break;
        case 'email-transfer':
          console.log('去邮箱转让');
          break;
        case 'logout':
          localStorage.removeItem('token');
          localStorage.removeItem('agentUserInfo');
          this.$router.push('/login');
          console.log('退出登录');
          break;
        default:
          break;
      }
    },
    async fetchUserInfoByAccountNum() {
      const accountNum = localStorage.getItem('agentUserInfo').replace(/^"|"$/g, '');
      if (!accountNum) {
        console.error('未找到 userName 字段');
        return;
      }
      try {
        const res = await axios.get(`/api/agentUsers/selectByaccountNum?accountNum=${accountNum}`);
        this.userInfo = res.data;
        if (res.data && res.data.data.userName) {
          this.username = res.data.data.userName;
        }
      } catch (e) {
        console.error('获取用户信息失败', e);
      }
    },
  }
};
</script>

<style scoped>
.app-layout {
  width: 100vw;
  height: 100vh;
}
.contain {
  height: 100vh;
  overflow: hidden;
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 64px;
  background: #fff;
  box-shadow: 0 2px 8px 0 rgba(0,0,0,0.04);
  padding: 0 32px;
}
.header-nav-active {
  display: flex;
  align-items: center;
  margin-right: 32px;
}
.header-nav-icon {
  width: 28px;
  height: 28px;
  margin-right: 10px;
}
.header-nav-text {
  font-size: 20px;
  color: #2EA2FA;
  font-weight: bold;
  letter-spacing: 1px;
}
.user-info {
  display: flex;
  align-items: center;
}
.el-dropdown-link {
  cursor: pointer;
  color: #333;
  font-size: 16px;
}
.user-icon {
  font-size: 22px;
  margin-right: 8px;
  vertical-align: middle;
}
.main-content {
  display: flex;
}
.sidebar {
  position: relative;
  width: 280px !important;
  min-height: 100vh;
  background: #2EA2FA;
  overflow: hidden;
  padding: 10px;
}
.sidebar-bg {
  position: absolute;
  top: 0; left: 0; right: 0; bottom: 0;
  background: url('~@/assets/sidebar-bg.png') no-repeat center center;
  background-size: cover;
  z-index: 1;
}
.sidebar-logo {
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90px;
  margin-bottom: 0px;
}
.sidebar-logo img {
  height: 60px;
}
.nav-menu {
  position: relative;
  z-index: 2;
  background: transparent !important;
  border-right: none;
}
.navmenu {
  display: flex;
  align-items: center;
  height: 56px;
  padding: 0 24px;
  background: transparent;
  color: #ffffff;
  font-size: 20px;
  border-radius: 8px;
  margin-bottom: 8px;
  transition: background 0.3s, color 0.3s;
}
.navmenu-active {
  background: #fff;
  color: #2EA2FA !important;
  font-weight: 500;
}
.nav-icon {
  width: 28px;
  height: 28px;
  margin-right: 14px;
}
.nav-text {
  flex: 1;
  text-align: left;
  letter-spacing: 1px;
}
.nav-star {
  width: 22px;
  height: 22px;
  margin-left: 14px;
}
.content {
  padding: 20px;
  background-color: #EBF6FE;
}
.el-dropdown-link{
  margin-right: 20px;
}
.warning-active {
  animation: warning-blink 1s infinite;
  color: #fff !important;
  background: #ff4d4f !important;
}
@keyframes warning-blink {
  0%, 100% { background: #ff4d4f; }
  50% { background: #fff; color: #ff4d4f; }
}
</style>
